module.exports = {
      id: "unchecked-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#unchecked",
      toString: function () {
        return this.url;
      }
    }